function handler(el, binding) {
  let text = el.textContent;
  if (text.length > binding.value) {
    if (binding.modifiers.center) {
      const pieceLength = Math.floor((binding.value - 3) / 2);
      text = `${text.slice(0, pieceLength)}...${text.slice(-pieceLength)}`;
    } else {
      text = text.slice(0, binding.value);
      if (binding.modifiers.lastspace) {
        const lastSpaceIndex = text.lastIndexOf(' ');
        if (![-1, 0].includes(lastSpaceIndex)) {
          text = text.substring(0, lastSpaceIndex);
        }
      }
      text = `${text}...`;
    }
    Object.assign(el, { textContent: text });
  }
  return el;
}

export default {
  componentUpdated(el, binding) {
    handler(el, binding);
  },
  inserted(el, binding) {
    handler(el, binding);
  },
};
